/* eslint-disable complexity */
import React from "react";
import { Col, Row, Spin } from "antd";
import { googleAds } from "appConfig";

import styles from "./myAdsList.scss";
import GoogleAd from "../../../../components/GoogleAd";
import { LocalStorageKey } from "../../../../models";
import { AdCard } from "../AdCard/AdCard";

const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;

const getDiscountPromoAdIndex = (ads) => {
  const discountPromoInLocalStorage = localStorage.getItem(LocalStorageKey.wasDiscountPromoShown);
  const discountPromoInLocalStorageParsed = discountPromoInLocalStorage ? JSON.parse(discountPromoInLocalStorage) : {}

  const recentShowCount = Object.values(discountPromoInLocalStorageParsed).filter(
    (timestamp) => Date.now() - Number(timestamp) < THIRTY_DAYS_IN_MS
  ).length;

  if (recentShowCount >= 3) return -1;

  const orderedAndFilteredAds = [...ads]
    .filter(ad => ad.priceReductionEligibilityOrder != null)
    .sort((a, b) => a.priceReductionEligibilityOrder - b.priceReductionEligibilityOrder)

  const nextEligibleAd = orderedAndFilteredAds.find(ad => {
    // select this ad index if there is no history of it being selected before
    if (!discountPromoInLocalStorageParsed[ad.id]) return true;

    const didThirtyDaysPass = Date.now() - Number(discountPromoInLocalStorageParsed[ad.id]) > THIRTY_DAYS_IN_MS
    return didThirtyDaysPass // select this ad index if thirty days have passed since last it's been selected
  })

  return nextEligibleAd && ads.findIndex(ad => nextEligibleAd.id === ad.id)
}



const defaultRenderGoogleAds = (
  index: any,
  isMobile: any,
  showGoogleAds: any
) => {
  if (!showGoogleAds) {
    return null;
  }

  if (isMobile) {
    // show different google ads each 5 unit
    switch (index) {
      case 5:
        return (
          <GoogleAd
            className={styles.adsMobile}
            config={{
              ...googleAds.searchResultMobile.box1,
              id: "googleAds.searchResultMobile.box1"
            }}
          />
        );

      case 10:
        return (
          <GoogleAd
            className={styles.adsMobile}
            config={{
              ...googleAds.searchResultMobile.box2,
              id: "googleAds.searchResultMobile.box2"
            }}
          />
        );

      case 15:
        return (
          <GoogleAd
            className={styles.adsMobile}
            config={{
              ...googleAds.searchResultMobile.box3,
              id: "googleAds.searchResultMobile.box3"
            }}
          />
        );

      case 20:
        return (
          <GoogleAd
            className={styles.adsMobile}
            config={{
              ...googleAds.searchResultMobile.box4,
              id: "googleAds.searchResultMobile.box4"
            }}
          />
        );

      default:
        return null;
    }
  }

  if (index % 3 === 2) {
    return (
      <div className={styles.ads}>
        <GoogleAd
          className={styles.adsChild}
          config={{
            ...googleAds.searchResult.boxLeft,
            id: `googleAds.searchResult.box1-${index}`
          }}
        />
        <GoogleAd
          className={styles.adsChild}
          config={{
            ...googleAds.searchResult.boxRight,
            id: `googleAds.searchResult.box2-${index}`

          }}
        />
      </div>
    );
  }

  return null;
};

function MyAdsList({
  ads,
  responsiveProps,
  adCardProps,
  gutter,
  AdCardComponent,
  emptyAdsText,
  className,
  showGoogleAds,
  renderGoogleAds,
  category
}) {

  const discountPromoAdIndex = getDiscountPromoAdIndex(ads)

  return ads ? ( // eslint-disable-line
    ads.length === 0 ? (
      <h2 className={styles.emptyAdsText}>{emptyAdsText}</h2>
    ) : (
      <React.Fragment>

        {ads.map((ad: any, index: any) => (
          <div key={ad.id} id={`my-ads-card-${ad.id}`}>
            {renderGoogleAds(index, adCardProps.isMobile, showGoogleAds)}
            <AdCardComponent ad={ad} {...adCardProps} category={category} shouldShowDiscountPromoTooltip={index === discountPromoAdIndex} />
          </div>
        ))}
      </React.Fragment>
    )
  ) : (
    <Spin className={styles.loading} tip={"Učitavam..."} size="large" />
  );
}

MyAdsList.defaultProps = {
  adCardProps: {},
  responsiveProps: {},
  gutter: 0,
  AdCardComponent: AdCard,
  emptyAdsText: "Ovdje nema oglasa!",
  className: styles.myAdsList,
  showGoogleAds: false,
  renderGoogleAds: defaultRenderGoogleAds
};

export default MyAdsList;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/MyAdsList/MyAdsList.tsx